module.exports = __webpack_public_path__ + "static/media/Calendar.fbe27095.svg";